import { render } from "./AiAgentForm.vue?vue&type=template&id=01665c0d&scoped=true&ts=true"
import script from "./AiAgentForm.vue?vue&type=script&lang=ts"
export * from "./AiAgentForm.vue?vue&type=script&lang=ts"

import "./AiAgentForm.vue?vue&type=style&index=0&id=01665c0d&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01665c0d"]])

export default __exports__